import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Logo from './components/Logo';
import Layout from './components/Layout';
import MainRow from './components/MainRow';
import Navicon from './components/Navicon';
import Nav from './components/Nav';
import Sidebar from './components/SidebarWrapper';
import {
    CareersAtFiverrLink,
    LifeAtFiverrLink,
    SeeAllPositionsLink,
    TeamsLabel,
    TeamLink,
} from './components/CustomLinks';

import './style.scss';

const Header = ({ user, teams, children }) => {
    const classes = classnames('careers-page-header', user?.id ? 'logged-in' : 'logged-out');

    return (
        <Layout className={classes} isSticky>
            <MainRow>
                <Navicon />
                <Logo />

                {!!children && <div className="content-container">{children}</div>}

                <Nav alignToRight>
                    <Nav.Item displayFromMD>
                        <CareersAtFiverrLink />
                    </Nav.Item>

                    <Nav.Item displayFromMD>
                        <LifeAtFiverrLink />
                    </Nav.Item>

                    <Nav.Item displayFromMD>
                        <Nav.PopoverItems target={<TeamsLabel />} key={global.location && global.location.href}>
                            {teams.map((team) => (
                                <Nav.PopoverItem key={team.link}>
                                    <TeamLink team={team} />
                                </Nav.PopoverItem>
                            ))}

                            <Nav.PopoverDivider />

                            <Nav.Item displayFromSM>
                                <SeeAllPositionsLink />
                            </Nav.Item>
                        </Nav.PopoverItems>
                    </Nav.Item>

                    <Nav.Item displayFromMD>
                        <SeeAllPositionsLink isInHeader />
                    </Nav.Item>
                </Nav>
            </MainRow>
            <Sidebar teams={teams} />
        </Layout>
    );
};

Header.propTypes = {
    user: PropTypes.object,
    children: PropTypes.node,
    teams: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
            link: PropTypes.string,
        })
    ),
};

Header.defaultProps = {
    user: {},
    children: null,
};

export default Header;
